//import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                notice: colors.red.accent4, // #E53935
                red: colors.red,
            },
        },
    },
    breakpoint: {
        mobileBreakpoint: 'xs',
    }
});
